/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:d34fe2f6-9602-4b92-92da-98ac1432d0c6",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_iwgKfhW0d",
    "aws_user_pools_web_client_id": "665080kk7vclvamh2145knbu7e",
    "oauth": {}
};


export default awsmobile;
